import { useContext } from 'react';
import { BasketContext } from '../contexts/Basket.context';

export const useBasket = () => {
  return useContext(BasketContext);
}; 